/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Captain_ShortInputs */

const es_nav_captain_short = /** @type {(inputs: Nav_Captain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eres patrón?`)
};

const gl_nav_captain_short = /** @type {(inputs: Nav_Captain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es un patrón?`)
};

const en_nav_captain_short = /** @type {(inputs: Nav_Captain_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you a skipper?`)
};

/**
* | output |
* | --- |
* | "Are you a skipper?" |
*
* @param {Nav_Captain_ShortInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_captain_short = /** @type {((inputs?: Nav_Captain_ShortInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Captain_ShortInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_captain_short(inputs)
	if (locale === "en") return en_nav_captain_short(inputs)
	return es_nav_captain_short(inputs)
});